import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

const SvgComponent = props => (
    <Svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
        <Path
            d="M7.86266 18.176L9.74469 15.0957C9.99572 14.6846 10.4403 14.4343 10.9189 14.4343H13.0768C13.5571 14.4343 14.0029 14.6864 14.2535 15.0996L16.1076 18.1573C17.1341 19.8688 19.0694 20.5529 20.6561 19.4598C21.633 18.787 22.1418 17.6092 21.9655 16.4288L20.7103 8.02237C20.5981 7.27026 20.3125 6.61679 19.9094 6.0795C19.1127 4.8286 17.7216 4 16.139 4H7.86971C6.29593 4 4.91172 4.81932 4.11283 6.05845C3.7051 6.59729 3.41604 7.25398 3.30229 8.01068L2.03479 16.4423C1.85677 17.6267 2.37164 18.8083 3.35669 19.4761C4.93342 20.5451 6.86463 19.9124 7.86266 18.176Z"
            stroke="#C06EF7"
            strokeWidth={1.75}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <Path
            d="M9.25 9.375C9.25 9.85818 8.85825 10.25 8.375 10.25C7.89175 10.25 7.5 9.85818 7.5 9.375C7.5 8.89182 7.89175 8.5 8.375 8.5C8.85825 8.5 9.25 8.89182 9.25 9.375Z"
            fill="#C06EF7"
            stroke="#C06EF7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <Path
            d="M16.5 9.375C16.5 9.85818 16.1082 10.25 15.625 10.25C15.1418 10.25 14.75 9.85818 14.75 9.375C14.75 8.89182 15.1418 8.5 15.625 8.5C16.1082 8.5 16.5 8.89182 16.5 9.375Z"
            fill="#C06EF7"
            stroke="#C06EF7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Svg>
);

export default SvgComponent;
